document.addEventListener("DOMContentLoaded", () => {
  const galleryWrapperSelector = ".grid__item.product__media-wrapper";

  const initStickyGallery = () => {
    const galleryWrapper = document.querySelector(galleryWrapperSelector);
    const artworkForm = document.getElementById("tee-artwork-form");

    if (!galleryWrapper || !artworkForm) {
      return;
    }

    const style = document.createElement("style");

    style.textContent = `
      /*
       * Sticky-Vorschau
       */
      .gallery--sticky ${galleryWrapperSelector} .tee-gallery-content {
        background: #fff;
        box-shadow: 0 2px 7px rgba(0, 0, 0, 0.22);
        display: flex;
        justify-content: center;
        left: 0;
        position: fixed;
        top: 0;
        transform: translateY(0);
        transition: transform 0.35s ease;
        width: 100vw;
        will-change: transform;
        z-index: 99;
      }

      /*
       * Eingeklappt bleiben 10 % der Vorschau sichtbar.
       */
      .gallery--sticky.gallery--sticky-collapsed
      ${galleryWrapperSelector} .tee-gallery-content {
        transform: translateY(-70%);
      }

      .gallery--sticky ${galleryWrapperSelector} .tee-gallery {
        width: auto;
        zoom: 0.7;
      }

      .gallery--sticky ${galleryWrapperSelector} .tee-thumbnails,
      .gallery--sticky ${galleryWrapperSelector} .tee-slider__dots {
        display: none;
      }

      /*
       * Mittiger Pfeil-Button
       */
      .gallery-toggle-button {
        align-items: center;
        background: #700404;
        border: 2px solid #fff;
        border-radius: 50%;
        bottom: -19px;
        box-shadow: 0 2px 7px rgba(0, 0, 0, 0.28);
        color: #fff;
        cursor: pointer;
        display: none;
        height: 38px;
        justify-content: center;
        left: 50%;
        padding: 0;
        position: absolute;
        transform: translateX(-50%);
        width: 38px;
        z-index: 1000;
      }

      .gallery--sticky .gallery-toggle-button {
        display: flex;
      }

      .gallery-toggle-button svg {
        display: block;
        height: 20px;
        pointer-events: none;
        transition: transform 0.25s ease;
        width: 20px;
      }

      /*
       * Geöffnet: Pfeil nach oben
       * Eingeklappt: Pfeil nach unten
       */
      .gallery--sticky.gallery--sticky-collapsed
      .gallery-toggle-button svg {
        transform: rotate(180deg);
      }

      .gallery-toggle-button:active {
        transform: translateX(-50%) scale(0.94);
      }

      @media (prefers-reduced-motion: reduce) {
        .gallery--sticky ${galleryWrapperSelector} .tee-gallery-content,
        .gallery-toggle-button svg {
          transition: none;
        }
      }
    `;

    document.head.appendChild(style);

    let toggleButtonCreated = false;
    let ticking = false;

    const resetGallery = () => {
      document.body.classList.remove(
        "gallery--sticky",
        "gallery--sticky-collapsed"
      );

      galleryWrapper.style.removeProperty("height");

      const toggleButton = document.querySelector(".gallery-toggle-button");

      if (toggleButton) {
        toggleButton.setAttribute("aria-expanded", "true");
        toggleButton.setAttribute(
          "aria-label",
          "Vorschau nach oben einklappen"
        );
      }
    };

    const createToggleButton = (teeGallery) => {
      if (toggleButtonCreated) {
        return;
      }

      const toggleButton = document.createElement("button");

      toggleButton.type = "button";
      toggleButton.className = "gallery-toggle-button";
      toggleButton.setAttribute("aria-expanded", "true");
      toggleButton.setAttribute(
        "aria-label",
        "Vorschau nach oben einklappen"
      );

      toggleButton.innerHTML = `
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M5 15.5L12 8.5L19 15.5"
            fill="none"
            stroke="currentColor"
            stroke-width="2.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      `;

      toggleButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const isCollapsed = document.body.classList.toggle(
          "gallery--sticky-collapsed"
        );

        toggleButton.setAttribute(
          "aria-expanded",
          String(!isCollapsed)
        );

        toggleButton.setAttribute(
          "aria-label",
          isCollapsed
            ? "Vorschau nach unten ausklappen"
            : "Vorschau nach oben einklappen"
        );
      });

      teeGallery.appendChild(toggleButton);
      toggleButtonCreated = true;
    };

    const updateStickyGallery = () => {
      ticking = false;

      const teeGallery = galleryWrapper.querySelector("#tee-gallery");

      if (!teeGallery) {
        return;
      }

      createToggleButton(teeGallery);

      const galleryContent =
        galleryWrapper.querySelector(".tee-gallery-content");

      if (!galleryContent) {
        return;
      }

      const galleryTop = galleryWrapper.getBoundingClientRect().top;
      const formBottom = artworkForm.getBoundingClientRect().bottom;
      const galleryHeight = galleryContent.offsetHeight;

      const shouldBeSticky =
        galleryTop < -10 && formBottom > galleryHeight;

      if (shouldBeSticky) {
        document.body.classList.add("gallery--sticky");

        /*
         * Verhindert einen Sprung im Seiteninhalt,
         * sobald die Galerie fixed positioniert wird.
         */
        galleryWrapper.style.height = `${galleryHeight + 10}px`;
      } else {
        /*
         * Sobald die eigentliche Galerie wieder sichtbar ist,
         * wird auch der eingeklappte Zustand zurückgesetzt.
         */
        resetGallery();

        window.dispatchEvent(new Event("resize"));
      }
    };

    const requestUpdate = () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(updateStickyGallery);
    };

    window.addEventListener("scroll", requestUpdate, {
      passive: true
    });

    window.addEventListener("resize", requestUpdate);

    /*
     * Teeinblue benötigt etwas Zeit, um die Galerie aufzubauen.
     */
    const galleryObserver = new MutationObserver(() => {
      const teeGallery = galleryWrapper.querySelector("#tee-gallery");

      if (teeGallery) {
        createToggleButton(teeGallery);
        requestUpdate();
        galleryObserver.disconnect();
      }
    });

    galleryObserver.observe(galleryWrapper, {
      childList: true,
      subtree: true
    });

    requestUpdate();
  };

  const width = window.innerWidth;
  const height = window.innerHeight;

  /*
   * Wie bisher ausschließlich mobil im Hochformat.
   */
  if (width < 768 && height / width > 1.5) {
    setTimeout(initStickyGallery, 2000);
  }
});